
    <kendo-tabstrip class="tabstrip import-tabstrip" (tabSelect)="onTabSelect($event)" >
      <!-- Projects Tab -->
      <kendo-tabstrip-tab title="Projects" [selected]="true">
        <ng-template kendoTabContent>
          <div class="tab-pane">
            <div class="section form-row with-gap">

               <input type="text" class="kendo-like-input search-input" placeholder="Search on Project Name or ID or Number"
                        [(ngModel)]="searchTerm" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilter($event)"  />
              <kendo-grid-spacer></kendo-grid-spacer>
              <!-- Location Selector -->
              <kendo-dropdownlist
                #locationDd="kendoDropDownList"
                class="location-dd"
                [style.width.px]="locationWidth"
                [data]="locations"
                textField="label"
                valueField="value"
                [valuePrimitive]="true"
                [defaultItem]="{ label: 'Select location...', value: null }"
                (valueChange)="onLocationChange($event)"
                [disabled]="loading"
                class="w-300"
              >
              </kendo-dropdownlist>

              <!-- Action / Status -->
              <button kendoButton
                      class="ml-8"
                      [primary]="true"
                      [disabled]="!selectedLocation || loading"
                      (click)="fetchProjects()">
                {{ loading ? 'Loading...' : 'Load Projects' }}
              </button>

              <span class="status" *ngIf="error">{{ error }}</span>
            </div>

            <!-- Projects Grid -->
            <div class="grid-section">
              <!-- NEW: wrapper that controls scroll and prevents footer clipping -->
              <div class="grid-wrapper">
                <kendo-grid
                  class="projects-grid k-grid k-grid-header custom2 compact-rows"
                  [style.width.vw]="86"
                  [loading]="loading"
                  [filterable]="false"
                  [sortable]="true"
                  [height]="380"
                  [kendoGridBinding]="projects"
                  [selectable]="{ checkboxOnly: true, mode: 'single' }"
                  kendoGridSelectBy="idocs_project_id"
                  [(selectedKeys)]="selectedKeys"
                >
                  <!-- Checkbox selection column -->
                  <kendo-grid-checkbox-column [width]="25">
                    <ng-template kendoGridHeaderTemplate>
                      <!-- Empty to hide header content -->
                    </ng-template>
                  </kendo-grid-checkbox-column>

                  <!-- Columns -->
                  <kendo-grid-column field="projectname" title="Project Name" [width]="250">
                  </kendo-grid-column>

                  <kendo-grid-column field="idocs_project_id" title="Project ID" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="idocs_project_number" title="Project No" [width]="150">
                  </kendo-grid-column>
                </kendo-grid>
              </div>
            </div>

            <!-- Bottom action row (always visible) -->
            <div class="import-row" *ngIf="projects?.length">
              <button kendoButton
                      [primary]="true"
                      [disabled]="!selectedKeys.length || importLoading"
                      (click)="importSelected()">
                {{ importLoading ? 'Importing...' : 'Import Selected' }}
              </button>

              <span class="muted" *ngIf="selectedKeys?.length">
                {{ selectedKeys.length }} selected
              </span>
            </div>

            <div class="empty"></div>
            <!-- Empty State -->
            <div class="empty" *ngIf="!loading && projects && projects.length === 0">
              No projects found for the selected location.
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

       <!-- Companies Tab -->
      <kendo-tabstrip-tab title="Companies">
         <ng-template kendoTabContent>
          <div class="tab-pane">
            <div class="section form-row with-gap">

               <input type="text" class="kendo-like-input search-input" placeholder="Search on Company Name"
                        [(ngModel)]="searchTermCompany" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterCompany($event)"  />
              <kendo-grid-spacer></kendo-grid-spacer>
              
              <kendo-dropdownlist
                #projectDd="kendoDropDownList"
                class="project-dd w-300"
                [style.width.px]="430"
                
                [data]="projectList"
                textField="projectname"
                valueField="projectId"
                [valuePrimitive]="false"
                [defaultItem]="{
                  projectname: 'Select project...',
                  projectId: null
                }"
                [value]="selectedProject"
                (valueChange)="onProjectChange($event)"
                [disabled]="loading"
                
              >
             </kendo-dropdownlist>


              <!-- Action / Status -->
              <button kendoButton
                      class="ml-8"
                      [primary]="true"
                      [disabled]="!selectedProject.projectId || loading"
                      (click)="fetchCompanies()">
                {{ loading ? 'Loading...' : 'Load Companies' }}
              </button>

              <span class="status" *ngIf="error">{{ error }}</span>
            </div>

            <!-- Projects Grid -->
            <div class="grid-section">
              <!-- NEW: wrapper that controls scroll and prevents footer clipping -->
              <div class="grid-wrapper">
                <kendo-grid
                  class="projects-grid k-grid k-grid-header custom2 compact-rows"
                  [style.width.vw]="86"
                  [loading]="loading"
                  [filterable]="false"
                  [sortable]="true"
                  [height]="380"
                  [kendoGridBinding]="companies"
                  [selectable]="{ checkboxOnly: true, mode: 'multiple' }"
                  kendoGridSelectBy="company_id"
                  [(selectedKeys)]="selectedCompanyKeys"
                  [isRowSelectable]="isRowSelectable"
                  [rowClass]="rowClass"
                >
                  <!-- Checkbox selection column -->
                  <kendo-grid-checkbox-column [width]="25">
                    <ng-template kendoGridHeaderTemplate>
          
                      <input
                        type="checkbox"
                        kendoCheckBox
                        kendoGridSelectAllCheckbox
                      />
                    </ng-template>
                  </kendo-grid-checkbox-column>

                  <!-- Columns -->
                  <kendo-grid-column field="company_name" title="Name" [width]="250">
                  </kendo-grid-column>

                  <kendo-grid-column field="address" title="Address" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="city" title="City" [width]="150">
                  </kendo-grid-column>

                   <kendo-grid-column field="state" title="State" [width]="250">
                  </kendo-grid-column>

                  <kendo-grid-column field="zip" title="ZIP" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="phone" title="Phone" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="recipient_code" title="Recipient Code" [width]="150">
                  </kendo-grid-column>
                </kendo-grid>
              </div>
            </div>

            <!-- Bottom action row (always visible) -->
            <div class="import-row" *ngIf="companies?.length">
              <button kendoButton
                      [primary]="true"
                      [disabled]="!selectedCompanyKeys.length || importLoading"
                      (click)="importSelectedCompanies()">
                {{ importLoading ? 'Importing...' : 'Import Selected' }}
              </button>

              <span class="muted" *ngIf="selectedCompanyKeys?.length">
                {{ selectedCompanyKeys.length }} selected
              </span>
            </div>

            <div class="empty"></div>
            <!-- Empty State -->
            <div class="empty" *ngIf="!loading && companies && companies.length === 0">
              No companies found for the selected project's location.
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Orders Tab -->
      <kendo-tabstrip-tab title="Orders">
        <ng-template kendoTabContent>
          <!-- You can drop your existing <app-objects> here if needed -->
          <div class="tab-pane">
            <div class="section form-row with-gap">

              <input type="text" class="kendo-like-input search-input" placeholder="Search"
                        [(ngModel)]="searchTermOrder" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterOrder($event)"  />
              <kendo-grid-spacer></kendo-grid-spacer>
              
              <kendo-dropdownlist
                #projectDd="kendoDropDownList"
                class="project-dd w-300"
                [style.width.px]="430"
                
                [data]="projectList"
                textField="projectname"
                valueField="projectId"
                [valuePrimitive]="false"
                [defaultItem]="{
                  projectname: 'Select project...',
                  projectId: null
                }"
                [value]="selectedProject"
                (valueChange)="onProjectChange($event)"
                [disabled]="loading"
                
              >
              </kendo-dropdownlist>


              <!-- Action / Status -->
              <button kendoButton
                      class="ml-8"
                      [primary]="true"
                      [disabled]="!selectedProject.projectId || loading"
                      (click)="fetchOrders()">
                {{ loading ? 'Loading...' : 'Load Orders' }}
              </button>

              <span class="status" *ngIf="error">{{ error }}</span>
            </div>
            <!-- Order Grid -->
            <div class="grid-section">
              <!-- NEW: wrapper that controls scroll and prevents footer clipping -->
              <div class="grid-wrapper">
                <kendo-grid
                  class="projects-grid k-grid k-grid-header custom2 compact-rows"
                  [style.width.vw]="86"
                  [loading]="loading"
                  [filterable]="false"
                  [sortable]="true"
                  [height]="380"
                  [kendoGridBinding]="orders"
                  [selectable]="{ checkboxOnly: true, mode: 'multiple' }"
                  kendoGridSelectBy="order_no"
                  [(selectedKeys)]="selectedOrderKeys"
                  [isRowSelectable]="isOrderRowSelectable"
                  [rowClass]="rowClass"
                >
                  <!-- Checkbox selection column -->
                  <kendo-grid-checkbox-column [width]="25">
                    <ng-template kendoGridHeaderTemplate>
          
                      <input
                        type="checkbox"
                        kendoCheckBox
                        kendoGridSelectAllCheckbox
                      />
                    </ng-template>
                  </kendo-grid-checkbox-column>

                  <!-- Columns -->
                  <kendo-grid-column field="order_no" title="Order No" [width]="250">
                  </kendo-grid-column>

                  <kendo-grid-column field="order_description" title="Order Description" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="company_name" title="Company Name" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span
                        [ngClass]="{
                          'missing-company': !dataItem.companyPresent
                        }"
                      >
                        {{ dataItem.company_name }}
              
                      </span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column field="recipient_code" title="Recipient Code" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span
                        [ngClass]="{
                          'missing-company': !dataItem.companyPresent
                        }"
                      >
                        {{ dataItem.recipient_code }}
                        
                      </span>
                    </ng-template>
                  </kendo-grid-column>

                </kendo-grid>
              </div>
            </div>

            <!-- Bottom action row (always visible) -->
            <div class="import-row" *ngIf="orders?.length">
              <button kendoButton
                      [primary]="true"
                      [disabled]="!selectedOrderKeys.length || importLoading"
                      (click)="importSelectedOrders()">
                {{ importLoading ? 'Importing...' : 'Import Selected' }}
              </button>

              <span class="muted" *ngIf="selectedOrderKeys?.length">
                {{ selectedOrderKeys.length }} selected
              </span>
            </div>

            <div class="empty"></div>
            <!-- Empty State -->
            <div class="empty" *ngIf="!loading && orders && orders.length === 0">
              No orders found for the selected project.
            </div>
          
          </div>
        </ng-template>
        
      </kendo-tabstrip-tab>

      <!-- Users Tab -->
      <kendo-tabstrip-tab title="Users">
        <ng-template kendoTabContent>
          <!-- You can drop your existing <app-objects> here if needed -->
          <div class="tab-pane">
            <div class="section form-row with-gap users-row">

              <input type="text" class="kendo-like-input search-input" placeholder="Search"
                        [(ngModel)]="searchTermUser" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterUser($event)"  />
              
              <kendo-dropdownlist
                #projectDd="kendoDropDownList"
                class="project-dd w-300"
                [style.width.px]="400"
                
                [data]="projectList"
                textField="projectname"
                valueField="projectId"
                [valuePrimitive]="false"
                [defaultItem]="{
                  projectname: 'Select project...',
                  projectId: null
                }"
                [value]="selectedProject"
                (valueChange)="onProjectChange($event)"
                [disabled]="loading"
                
              >
              </kendo-dropdownlist>


              <!-- Action / Status -->
              <button kendoButton
                      class="ml-8"
                      [primary]="true"
                      [disabled]="!selectedProject.projectId || loading"
                      (click)="fetchUsers()">
                {{ loading ? 'Loading...' : 'Load Users' }}
              </button>

              <span class="status ml-8" *ngIf="error">{{ error }}</span>

              

              <div class="right-section" *ngIf="dataUsers?.length">
                <div class="portal-filter">
                  <label class="mr-4"><b>Exists in Portal</b></label>

                  <kendo-dropdownlist
                    [data]="portalFilterOptions"
                    textField="text"
                    valueField="value"
                    [(ngModel)]="selectedPortalFilter"
                    [ngModelOptions]="{ standalone: true }"
                    (valueChange)="onPortalFilterChange($event)"
                    style="width: 130px;"
                    [valuePrimitive]="true"
                  >
                  </kendo-dropdownlist>
                </div>
              </div>

            </div>
            
            <!-- User Grid -->
            <div class="grid-section">
              <!-- NEW: wrapper that controls scroll and prevents footer clipping -->
              <div class="grid-wrapper">
                <kendo-grid
                  class="projects-grid k-grid k-grid-header custom2"
                  [style.width.vw]="86"
                  [loading]="loading"
                  [filterable]="false"
                  [sortable]="true"
                  [height]="380"
                  [kendoGridBinding]="filteredUsers"
                  [selectable]="{ checkboxOnly: true, mode: 'multiple' }"
                  kendoGridSelectBy="user_email"
                  [(selectedKeys)]="selectedUserKeys"
                  [isRowSelectable]="isUserRowSelectable"
                  [rowClass]="rowClass"
                  (sortChange)="onSortChange($event)"
                >
                  <!-- Checkbox selection column -->
                  <kendo-grid-checkbox-column [width]="25">
                    <ng-template kendoGridHeaderTemplate>
          
                      <input
                        type="checkbox"
                        kendoCheckBox
                        kendoGridSelectAllCheckbox
                      />
                    </ng-template>
                  </kendo-grid-checkbox-column>

                  <!-- Columns -->
                  <!--<kendo-grid-column field="user_email" title="Email" [width]="250">
                  </kendo-grid-column>-->

                  <kendo-grid-column field="user_email" title="Email" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.user_email?.toLowerCase() }}
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column field="first_name" title="First Name" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="last_name" title="Last Name" [width]="150">
                  </kendo-grid-column>

                  <kendo-grid-column field="user_type" title="User Type" [width]="250">
                  </kendo-grid-column>

                 

                  <kendo-grid-column field="company" title="Company" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span
                        [ngClass]="{
                          'missing-company': !dataItem.companyPresent
                        }"
                      >
                        {{ dataItem.company }}
              
                      </span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column field="recipient_code" title="Recipient Code" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span
                        [ngClass]="{
                          'missing-company': !dataItem.companyPresent
                        }"
                      >
                        {{ dataItem.recipient_code }}
                        
                      </span>
                    </ng-template>
                  </kendo-grid-column>

                </kendo-grid>
              </div>
            </div>

            <!-- Bottom action row (always visible) -->
            <div class="import-row" *ngIf="dataUsers?.length">
              <button kendoButton
                      [primary]="true"
                      [disabled]="!selectedUserKeys.length || importLoading"
                      (click)="importSelectedUsers()">
                {{ importLoading ? 'Importing...' : 'Import Selected' }}
              </button>

              <span class="muted" *ngIf="selectedUserKeys?.length">
                {{ selectedUserKeys.length }} selected
              </span>
            </div>

            <div class="empty"></div>
            <!-- Empty State -->
            <div class="empty" *ngIf="!loading && filteredUsers && filteredUsers.length === 0">
              No users found for the selected project.
            </div>
          
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

      

    </kendo-tabstrip>

    <kendo-dialog
      *ngIf="showErrorDialog"
      (close)="showErrorDialog = false"
      [minWidth]="500">

      <kendo-dialog-titlebar>
          Invalid Email Addresses
      </kendo-dialog-titlebar>

      <div style="padding: 10px;">
          <p>
              The following users have invalid email addresses and cannot be imported:
          </p>

          <ul>
              <li *ngFor="let email of invalidEmails">
                  {{ email }}
              </li>
          </ul>
      </div>

      <kendo-dialog-actions>
          <button
              kendoButton
              themeColor="primary"
              (click)="showErrorDialog = false">
              OK
          </button>
      </kendo-dialog-actions>

  </kendo-dialog>

  